export const socialMedia = [
  { icon: 'LinkedinIcon', url: 'https://www.linkedin.com/company/pleez-company/' },
  { icon: 'InstagramIcon', url: 'https://www.instagram.com/pleezinternational/' },
  { icon: 'FacebookIcon', url: 'https://www.facebook.com/pleezcompany' },
  { icon: 'WhatsappIcon', url: 'whatsapp://send?phone=+351934068030' },
  { icon: 'EmailIcon', url: 'mailto:hello@pleez.pt' },
];
